import brand from '../brand/brand.json';

// API хаяг брэндээс. Local dev-д REACT_APP_API_URL-оор override хийж болно.
export const apiBaseUrl = process.env.REACT_APP_API_URL || `https://${brand.domains.api}/api`;

export default brand;
